<!-- 招贤纳士 -->
<template>
  <div class="jionUs">
    <div class="jc-sa table-header">
      <span class="span-w">招聘职位</span>
      <span class="span-w">招聘部门</span>
      <span class="span-w">工作地点</span>
      <span class="span-w">发布时间</span>
      <span class="span-w">职位申请</span>
    </div>
    <!-- <div>
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">
            <div class="title">
              <span class="span-w">cxxxxxxxxxxxxxxxxxxxxx</span>
              <span class="span-w">研发部</span>
              <span class="span-w">深圳</span>
              <span class="span-w">2019年9月4日</span>
              <span class="span-w">立即申请</span>
            </div>
          </template>
          <div class="detail">
            <p class="jc-sa border-b">
              <span class="span-w">工作地点：</span>
              <span class="span-w">年龄：</span>
              <span class="span-w">薪资待遇：</span>
              <span class="span-w">发布时间：</span>
              <span class="span-w">工作经验：</span>
              <span class="span-w">学历：</span>
              <span class="span-w">招聘人数：</span>
            </p>
            <div class="jc-sa">
              <p class="flex-clumn">
                <span>岗位职责:</span>
                <span>1</span>
                <span>1</span>
                <span>1</span>
              </p>
              <p class="flex-clumn">
                <span>任职要求:</span>
                <span>1</span>
                <span>1</span>
                <span>1</span>
              </p>
            </div>
          </div>
        </el-collapse-item>
    </el-collapse>-->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      jiinUsList: [{}]
    };
  },

  components: {},

  mounted() {},

  methods: {}
};
</script>
<style scoped>
.jionUs {
  min-width: 1080px;
}
.table-header {
  background: #c0bdbd;
  padding: 10px 0 10px 0;
  color: #fff;
  margin-top: 3%;
}
.title {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.jc-sa {
  display: flex;
  justify-content: space-around;
}
.border-b {
  padding-bottom: 10px;
  border-bottom: 2px solid #e2dbdb;
}
.detail {
  background: #f5f5f5;
}
.flex-clumn {
  display: flex;
  flex-direction: column;
}
.span-w {
  display: inline-block;
  width: 15%;
}
</style>